import React from "react";
import PropTypes from "prop-types";
import { Box, Pagination, Typography, Select, MenuItem, FormControl } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

const CustomPagination = ({
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
  onItemsPerPageChange,
  showItemsPerPage = true,
  itemsPerPageOptions = [5, 10, 25, 50],
  loading = false,
}) => {
  if (totalItems === 0) return null;

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <ArgonBox
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={3}
      flexDirection={{ xs: "column", sm: "row" }}
      gap={{ xs: 2, sm: 0 }}
    >
      {/* Items Info */}
      <ArgonTypography variant="body2" color="secondary">
        Showing {startItem} to {endItem} of {totalItems} entries
      </ArgonTypography>

      {/* Pagination Controls */}
      <ArgonBox display="flex" alignItems="center" gap={2}>
        {showItemsPerPage && (
          <ArgonBox display="flex" alignItems="center" gap={1}>
            <ArgonTypography variant="caption" color="secondary">
              Items per page:
            </ArgonTypography>
            <FormControl size="small">
              <Select
                value={itemsPerPage}
                onChange={(e) => onItemsPerPageChange && onItemsPerPageChange(e.target.value)}
                disabled={loading}
                sx={{ minWidth: 70, height: 32 }}
              >
                {itemsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </ArgonBox>
        )}

        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, value) => onPageChange && onPageChange(value)}
          color="primary"
          disabled={loading}
          showFirstButton
          showLastButton
          size="small"
        />
      </ArgonBox>
    </ArgonBox>
  );
};

CustomPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  itemsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onItemsPerPageChange: PropTypes.func,
  showItemsPerPage: PropTypes.bool,
  itemsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  loading: PropTypes.bool,
};

CustomPagination.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  totalItems: 0,
  itemsPerPage: 10,
  onPageChange: null,
  onItemsPerPageChange: null,
  showItemsPerPage: true,
  itemsPerPageOptions: [5, 10, 25, 50],
  loading: false,
};

export default CustomPagination;
